import { render, staticRenderFns } from "./ContactPerson.vue?vue&type=template&id=6743c96c"
import script from "./ContactPerson.vue?vue&type=script&lang=js"
export * from "./ContactPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports